import axios from 'axios';
// import swal from "sweetalert";
import Swal from "sweetalert2";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import authHeader from './auth-header';
import ApiService from './ApiService';
import { callAlert } from './CommonService';
import { addToCart, fetchCartItems } from '../store2/features/cartSlice';
import { useDispatch } from 'react-redux';


const BASE_URL = 'http://138.201.249.173:8091';



export function userDetails() {

    const result = axios.get(
        `${BASE_URL}/users/me`, { headers: authHeader() }
    );
    return result;


}


export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            // swal("Oops", "Email already exists", "error");
            Swal.fire({
                icon: 'error',
                title: 'Oops',
                text: 'Email already exists',
            })
            break;
        case 'EMAIL_NOT_FOUND':
            Swal.fire({
                icon: 'error',
                title: 'Oops',
                text: 'Email not found',
            })
            //return 'Email not found';
            //swal("Oops", "Email not found", "error",{ button: "Try Again!",});
            break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            // swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            Swal.fire({
                icon: 'error',
                title: 'Oops',
                text: 'Invalid Password',
            })
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}




export function setUserDetailsMode(key = "mode", value = "TR", modestatus = false) {
    let data = getUserDetails();
    data[key] = value;
    if (modestatus) {
        data["mode"] = "TR";
    }
    localStorage.setItem('userDetails', JSON.stringify(data));
}



export function getUserDetails() {
    const d = localStorage.getItem('userDetails');

    if (!d) {
        return;
    }

    return JSON.parse(d);

}


export function paymentDetails(data) {
    localStorage.setItem('pay', JSON.stringify(data));
}


export function getPaymentDetails(dispatch, navigate) {
    const d = localStorage.getItem('pay');

    if (!d) {
        return;
    }

    return JSON.parse(d);

}



export function setTrailDetails(d) {
    localStorage.removeItem('addToCart');
    localStorage.setItem('trialClass', JSON.stringify(d));
}


export function getTrailDetails() {
    const d = localStorage.getItem('trialClass');

    if (!d) {
        return;
    }

    return JSON.parse(d);

}


export function setAddToCartDetails(d) {
    localStorage.removeItem('trialClass');
    localStorage.setItem('addToCart', JSON.stringify(d));
}


// export function getAddToCartDetails() {
//     const d = localStorage.getItem('addToCart');
//     // const d = localStorage.getItem('');

//     if (!d) { 
//         return;
//     }

//     return JSON.parse(d);

// }

export function getAddToCartDetails() {
    const d = localStorage.getItem('addToCart');

    if (!d) {
        return null;
    }

    const parsed = JSON.parse(d);

    // ✅ Remove immediately after reading
    localStorage.removeItem('addToCart');

    return parsed;
}


export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}


// export const subscriptionTrial = (callback = null, dispatch = null) => {
//     let trail = getTrailDetails();
//     let addToCarts = getAddToCartDetails();
//     const userDetailss = getUserDetails();


//     if (trail && trail['modeClass']) {

//         if (userDetailss['mode'] == "NA") {

//             ApiService.publicPostRequest(`/subscription/trial`, {
//                 "courseId": trail['modeClass'],
//             }, true)
//                 .then((res) => {

//                     if (res.data?.resultCode === 1) {
//                         localStorage.removeItem('trialClass');
//                         setUserDetailsMode('trialExpiry', res.data.data[0]['expiryDate'], true);
//                         if (callback) { callback() }

//                     } else {
//                         callAlert('', res.data?.message);
//                     }

//                 })
//                 .catch((error) => {

//                     callAlert('', error?.error?.message);

//                 });


//         } else {
//             callAlert('', "You have already started your 7-day free trial for a class. 👉 Want access to full course? Subscribe at EFH!");
//             if (callback) { callback() }
//             localStorage.removeItem('trialClass');
//         }
//     } else if (addToCarts && addToCarts['modeClass']) {


//         /*  add to cart here  */
//         if (typeof dispatch === 'function') {
//             handleAddToCart(dispatch, addToCarts).then(() => {
//                 if (callback) callback('/cart');
//             });

//         }
//         /*  add to cart here  */


//     } else {


//         if (callback) { callback() }
//     }




// }


export const subscriptionTrial = async (callback = null, dispatch = null) => {
    try {
        const trail = getTrailDetails();
        const addToCarts = getAddToCartDetails();
        const userDetailss = getUserDetails();

        // 🟢 TRIAL LOGIC
        if (trail?.modeClass) {

            if (userDetailss?.mode === "NA") {

                const res = await ApiService.publicPostRequest(
                    `/subscription/trial`,
                    { courseId: trail.modeClass },
                    true
                );

                if (res.data?.resultCode === 1) {

                    localStorage.removeItem('trialClass');

                    setUserDetailsMode(
                        'trialExpiry',
                        res.data.data[0]['expiryDate'],
                        true
                    );

                    if (callback) callback();

                } else {
                    callAlert('', res.data?.message);
                }

            } else {

                callAlert(
                    '',
                    "You have already started your 7-day free trial for a class. 👉 Want access to full course? Subscribe at EFH!"
                );

                localStorage.removeItem('trialClass');

                if (callback) callback();
            }

            return;
        }

        // 🟢 ADD TO CART LOGIC
        if (addToCarts?.modeClass && typeof dispatch === 'function') {

            await handleAddToCart(dispatch, addToCarts);

            // ✅ IMPORTANT: remove after success
            localStorage.removeItem('addToCart');

            // ✅ OPTIONAL: force refresh cart from backend
            dispatch(fetchCartItems());  // if you have this action

            if (callback) callback('/cart');

            return;
        }

        if (callback) callback();

    } catch (error) {
        callAlert('', error?.error?.message || "Something went wrong");
    }
};


const handleAddToCart = async (dispatch, addToCarts) => {
    const result = await dispatch(addToCart(addToCarts['modeClass']));

    if (result?.payload?.resultCode !== 1) {
        localStorage.removeItem('addToCart');
        callAlert("", result.payload?.message);
    }
};

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }

    dispatch(loginConfirmedAction(tokenDetails));

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);





}
